module.exports = __webpack_public_path__ + "gd.svg?0e3d254c0cf13bf900b1eed7022fd68f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gd.svg
// module id = 1109
// module chunks = 0